import React from "react";

import { Legend } from "@jsluna/form";
import { Card } from "@jsainsburyplc/id-ui-common";

const SectionContainer = ({ children, label }) => (
  <Card>
    <Legend fontStyle="h2">{label}</Legend>
    <div className="section-container ln-u-margin-top*2">{children}</div>
  </Card>
);

export default SectionContainer;
